import {ApiService} from "../constants";
import {HttpService} from "./HttpService";

export const parseReturnUrl = (url: string) => {
    let targetUrl: URL;
    let useHref = localStorage.getItem('return_url:use_href');
    localStorage.removeItem('return_url:use_href');

    try {
        targetUrl = new URL(url, window.location.origin);
    } catch (e) {
        console.error(`Invalid return url: ${url}`);
        console.error(e);
        window.location.href = '/';
        return;
    }

    const beelajarLmsUrlOrigin = new URL(ApiService.beelajar.postRequestLogin).origin;
    const allowedOrigin = [window.location.origin, beelajarLmsUrlOrigin];

    if (!allowedOrigin.includes(targetUrl.origin)) {
        console.error(`Invalid return url: ${url}`);
        window.location.href = '/';
        return;
    }

    let beelajarLmsUrl: URL;

    try {
        beelajarLmsUrl = new URL(url);
    } catch (e) {
        beelajarLmsUrl = null;
    }

    if (beelajarLmsUrl?.origin === beelajarLmsUrlOrigin){
        const jsonString = localStorage.getItem('persist:root');
        const object = JSON.parse(jsonString);
        const profileUser = JSON.parse(object.auth).userData;
        HttpService.goToBeelajar(profileUser.userName, url, useHref == "true");
        return;
    }

    window.location.href = targetUrl.href;
}